/* eslint-disable no-param-reassign */
import axios, { AxiosError } from 'axios';
import { useEffect, useState } from 'react';

import AuthModule from '../auth/AuthModule';
import { ContractListRequest } from './types/contractListRequest';
import { ConctractListResponse } from './types/contractListResponse';

export const useContractList = (
  contractListRequest: ContractListRequest | null | undefined,
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState(null);
  const [serverError, setServerError] = useState(null);

  useEffect(() => {
    if (!contractListRequest) {
      return;
    }

    if (
      contractListRequest.locations.soldToParties.length <= 0 ||
      contractListRequest.contractStatus === 'none'
    ) {
      const noData = { rowCount: 0, contracts: [] } as any;
      setApiData(noData);
      return;
    }

    const request: ContractListRequest = {
      ...contractListRequest,
      offset: contractListRequest.offset * contractListRequest.upToRows,
      beginDateStart:
        contractListRequest.beginDateStart === null
          ? new Date('1900-12-31T02:00:00.000')
          : contractListRequest.beginDateStart,
      beginDateEnd:
        contractListRequest.beginDateEnd === null
          ? new Date('9999-12-31T02:00:00.000')
          : contractListRequest.beginDateEnd,
      contractTypes: contractListRequest.contractTypes?.some(
        (contractType) => contractType === 'all',
      )
        ? []
        : contractListRequest.contractTypes,
      contractUsages: contractListRequest.contractUsages?.some(
        (contractUsage) => contractUsage === 'all',
      )
        ? []
        : contractListRequest.contractUsages,
    };

    setIsLoading(true);
    const fetchData = async () => {
      try {
        const b2cToken =
          await AuthModule.getInstance().getProfileTokenRedirect();
        // have to use ignore
        const resp = await axios({
          method: 'POST',
          url: `${process.env.REACT_APP_BACKEND_API_URL}/contract/contractlist`,
          data: request,
          headers: {
            Authorization: `Bearer ${b2cToken}`,
            'Ocp-Apim-Subscription-Key': `${process.env.REACT_APP_API_KEY}`,
          },
        });
        const data = await resp?.data;

        setApiData(data);
        setIsLoading(false);
      } catch (error) {
        let errorCode;
        const axiosError = error as AxiosError;
        if (axiosError) errorCode = axiosError?.response?.data?.detail?.error;

        if (errorCode) {
          setServerError(errorCode as any);
        } else {
          // fallback
          setServerError(error as any);
        }
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractListRequest]);

  return {
    isLoading,
    contractList: apiData as unknown as ConctractListResponse,
    serverError,
  };
};
